import React, { useEffect, useState } from "react";
import "./style.css";
import {
  Layout,
  Empty,
  Breadcrumb,
  Table,
  Button,
  Space,
  Input,
  Row,
  Col,
  Divider,
  Spin,
  Tabs,
} from "antd";
import { useSelector, useDispatch } from 'react-redux';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { DownloadOutlined, SyncOutlined } from "@ant-design/icons";
import Container from "../Layout/Container";
import { Link, useHistory, useLocation } from "react-router-dom";
import { getViewAllProcess, AdminViewProcessSelector, clearState, takeActionAsyn, takeActionChildProcessAsyn } from './AdminViewProcessSlice';
import moment from 'moment';
const { Header, Content, Footer } = Layout;
const { Search } = Input;
const { TabPane } = Tabs;
const antIcon = <SyncOutlined style={{ fontSize: 24 }} spin />;
const ntop = "none";
const nbottom = "bottomCenter";



export default function ViewAllProcess() {

  const dispatch = useDispatch();
  const location = useLocation();
  let history = useHistory();
  const [isLoading, setLoading] = React.useState(false);
  const [isToast, setToast] = React.useState(false);
  const [processRecord, setprocessRecord] = useState([]);

  const { isFetching, isAllprocessSuccess, isError, errorMessage, allProcessData, concurrentDoc, processTimeLogs, signed, docPathname } = useSelector(
    AdminViewProcessSelector
  );


  useEffect(() => {
    setLoading(true);
    setToast(false);
    dispatch(clearState());
    dispatch(getViewAllProcess(location.state.processName));
  }, []);

  useEffect(() => {

    if (isError) {
      setprocessRecord([]);
      setLoading(false);
      setToast(true);
      toast.error(errorMessage);
      dispatch(clearState());
    }
    if (isAllprocessSuccess) {
      setLoading(false);
      setprocessRecord(allProcessData);
    }

  }, [isError, isAllprocessSuccess, setLoading, allProcessData, processTimeLogs, concurrentDoc, signed, docPathname]);


  const data = [
    {
      id: 1,
      process_action: "Seen Stamp Initiated",
      action_taken_by: "Homer Ryan",
      type: "Clerk",
      date_time: "11 Jun 2021, 11:43PM",
      doc_changes: "Uploaded",
      comments: "No",
    }
  ];

  const renderContent = (value, row, index) => {
    const obj = {
      children: value,
      props: {},
    };
    return obj;
  };

  const columns = [
    {
      title: "Seen Stamp Action",
      dataIndex: "process_action",
      render: renderContent,
    },
    {
      title: "Action Taken by",
      dataIndex: "action_taken_by",
      render: renderContent,
    },
    {
      title: "Type",
      dataIndex: "type",
      render: renderContent,
    },
    {
      title: "Date & Time",
      dataIndex: "date_time",
      render: renderContent,
    },
    {
      title: "Doc Changes",
      dataIndex: "doc_changes",
      render: (text, row, index) => {
        return {
          children: <p className="mar-b-0 process-time-log-docs"><span>{text}</span>
            {/* <Link to={row.dwnFile} target="_blank" download><DownloadOutlined /></Link> */}
            {row.doc_changes != "No"
              && <a href={row.dwnFile} download="My_File" target='_blank' style={{ color: 'rgb(37, 55, 217)', fontSize: 18 }} className="mar-l-10"><DownloadOutlined /></a>
            }

          </p>,
          props: {
            //colSpan: 5,
          },
        };
      },
    },
    {
      title: "Comments",
      dataIndex: "comments",
      render: renderContent,
    },
  ];

  const columnsForConcurentlog = [
    {
      title: "Seen Stamp Id",
      dataIndex: "process_id",
      render: renderContent,
    },
    {
      title: "Status",
      dataIndex: "p_status",
      render: renderContent,
    },
    {
      title: "File",
      dataIndex: "con_dwnFile",
      render: (text, row, index) => {
        return {
          children: <p className="mar-b-0 process-time-log-doc">
            {/* <span>File</span> */}
            {/* <Link to={row.dwnFile} target="_blank" download><DownloadOutlined /></Link> */}
            {row.p_status != "No"
              && <a href={text} download="My_File" target='_blank' style={{ color: 'rgb(37, 55, 217)', fontSize: 18 }} className="mar-l-0"><DownloadOutlined /></a>
            }
          </p>,
          props: {
            //colSpan: 5,
          },
        };
      },
    },
  ];



  const handleViewDocumentSeenStamp = (row) => {
    // console.log("click", row.processId);
    if (row.processId) {

      if (row.parentProcessId != null) {

        let takeActionChildProcess = dispatch(takeActionChildProcessAsyn(row.processId)).then((res) => {

          history.push({
            pathname: '/verify-document',
            state: { documentInfo: res.data, processId: row.processId }
          });

        });
      }
      else {

        let takeAction = dispatch(takeActionAsyn(row.processId)).then((res) => {
          // console.log('res', res)
          history.push({
            pathname: '/verify-document',
            state: { documentInfo: res.data, processId: res.data.documentUpdatedData.processId }
          });
        });

      }
    }
  }



  const handleStatusApprovedDelay = (record) => {

    var status = "";
    var msg = "";

    if (record && record.isSigned === true) {
      status = "text-color-success mar-t-15 seen-stamp-signed-stage";
      msg = "Signed";
    }
    else {
      status = "text-color-danger mar-t-15 seen-stamp-not-signed-stage";
      msg = "Not signed"
    }


    var result = {
      status: status,
      msg: msg,
    };

    return result;

  }


  let dataSource = isLoading
    ? []
    : processTimeLogs && processTimeLogs.length > 0 ? processTimeLogs.map(row => ({
      id: row._id,
      process_action: row.processAction,
      action_taken_by: row.actionTokenBy,
      type: row.type,
      date_time: moment(row.addedOn).format("lll"),
      doc_changes: row.isStatus,
      dwnFile: docPathname + row.pdfFile,
      comments: row && row.isComment && row.isComment === true ? "Yes" : "No",
    })) : [];



  let dataSource2 = isLoading
    ? []
    : concurrentDoc && concurrentDoc.length > 0 ? concurrentDoc.map(row => ({
      id: row._id,
      process_id: row.processId,
      p_status: row.status,
      con_dwnFile: docPathname + row.concurrentPdfFile,

    })) : [];


  return (
    <>
      <Container>
        <Breadcrumb style={{ padding: '26px 50px' }} separator=">">
          <Breadcrumb.Item><Link to="/all-seen-stamp">All Seen Stamp</Link></Breadcrumb.Item>
          <Breadcrumb.Item>DIT Seen Stamp</Breadcrumb.Item>
        </Breadcrumb>
        <div
          className="site-layout-content"
          style={{ paddingTop: 0 }}
        >
          <div>
            <Spin indicator={antIcon} style={{ textAlign: 'center', width: '100%' }} spinning={isLoading} />
            {isToast &&
              <Toaster
                toastOptions={{
                  className: '',
                  style: {
                    border: '1px solid #713200',
                    padding: '16px',
                    color: '#713200',
                    marginTop: 50
                  },
                }}
              >
                {(t) => (
                  <ToastBar toast={t}>
                    {({ icon, message }) => (
                      <>
                        {icon}
                        {message}
                        {t.type !== 'loading' && (
                          <button onClick={() => toast.dismiss(t.id)}>X</button>
                        )}
                      </>
                    )}
                  </ToastBar>
                )}
              </Toaster>
            }

            <Space
              style={{
                // padding: 16,
                width: "100%",
                // borderLeft: "1px solid #dfe0eb",
                // borderRight: "1px solid #dfe0eb",
              }}
              size="large"
            >
              <Row style={{ width: "100%" }}>
                <Col span="8" className="bg-fbfbfb pad-40" style={{ borderRight: 'solid 2px #f1f1f1', backgroundColor: '#e8f0f8' }}>
                  <h1 className="mar-b-30" style={{ fontWeight: "600", color: "#292c40", fontSize: "23px" }}>
                    <img src="./images/pdficon.png" style={{ width: "45px" }} />
                    &nbsp; DIT Seen Stamp
                  </h1>
                  <Row>
                    <Col span="12">
                      <p className="text-color-6b778c mar-b-5">Seen Stamp ID</p>
                      <p className="font-16 mar-b-25">{processRecord && processRecord.processId ? processRecord.processId : 'N/A'}</p>

                      <p className="text-color-6b778c mar-b-5">Download Restricted</p>
                      <p className="font-16 mar-b-25">{processRecord && processRecord.restrictDownload && processRecord.restrictDownload === true ? "Yes" : "No"}</p>

                      <p className="text-color-6b778c mar-b-5">Times Document Signed</p>
                      {/* <p className="font-16 mar-b-25">{processRecord && processRecord.signed ? processRecord.signed.length : "N/A"}</p> */}
                      <p className="font-16 mar-b-25">{processRecord && processRecord.signCount || processRecord.signCount === 0 ? processRecord.signCount : "N/A"}</p>
                    </Col>
                    <Col span="12" className="text-right">
                      <p className="text-color-6b778c mar-b-5">Added On</p>
                      <p className="font-16 mar-b-25">{processRecord && processRecord.addedOn ? moment(processRecord.addedOn).format("ll") : "N/A"}</p>

                      <p className="text-color-6b778c mar-b-5">Document Type</p>
                      <p className="font-16 mar-b-25">{processRecord && processRecord.documentType ? processRecord.documentType : "N/A"}</p>

                      <p className="text-color-6b778c mar-b-5">Recived From</p>
                      <p className="font-16 mar-b-25">{processRecord && processRecord.receivedFrom ? processRecord.receivedFrom : "N/A"}</p>
                    </Col>
                  </Row>

                  <Row>

                    <Col span="23">
                      <p className="text-color-6b778c mar-b-5">Subject</p>
                      <p className="font-16 mar-b-25">{processRecord && processRecord.processSubject ? processRecord.processSubject : "N/A"}</p>

                    </Col>
                    <Col span="1"></Col>
                  </Row>

                </Col>
                <Col span="16" className="bg-fbfbfb pad-40 #f1f1f1">

                  <Row>
                    <Col className="mar-b-25" span="12" style={{ textAlign: "Left" }}>
                      <h1 className="font-24" style={{ fontWeight: "600", color: "#292c40" }}>Seen Stamp Flow</h1>
                    </Col>
                    <Col span="12" style={{ textAlign: "right" }}>
                      <Space>
                        <Button
                          size="large"
                          style={{
                            borderRadius: 5,
                            padding: "3px 8px",
                            fontWeight: 600,
                            fontSize: 14,
                            height: '35px',
                          }}
                          onClick={(e) => handleViewDocumentSeenStamp(processRecord)}
                          type="primary"
                        >
                          View Document & Seen Stamp
                        </Button>
                      </Space>

                    </Col>
                  </Row>

                  {signed && signed.length > 0 ?

                    signed.map(function (row, item) {
                      // var str = 'Bob,1234,Bob@example.com;Mark,5678,Mark@example.com',
                      var timeArray = row && row.isSigned === true && row.signWithin && row.signWithin.time.split(':').map(a => a.split(','));

                      return (
                        <>
                          <div className="mar-b-30" key={item}>
                            {/* <h5 style={{ color: "#2537d9", fontWeight: "500" }} className="font-16 mar-b-20">Stage {item}</h5> */}
                            <h5 style={{ color: "#000000", fontWeight: "500" }} className="font-16 mar-b-10">Stage {row && row.stage}</h5>
                            <Space
                              style={{
                                padding: 16,
                                width: "100%",
                                backgroundColor: "#e8f0f8"
                              }}
                              size="large"
                            >
                              <Row>
                                {/* <Col span="6">

                                  <p className="text-color-6b778c mar-b-5">Respond Within</p>
                                  <p className="font-16 mar-b-0">{row && row.isSigned === true && row.signWithin ? row.signWithin.day + " day " + timeArray[0] + " Hours " + timeArray[1] + " Minutes " + timeArray[2] + " Second " : "N/A"}</p>

                                </Col> */}
                                <Col span="8">

                                  <p className="text-color-6b778c mar-b-5">Approved by</p>
                                  <p className="font-16 mar-b-0 single-line-text-dot" style={{ paddingRight: "15px" }}>{row && row.detailedUser && row.detailedUser.fullName ? row.detailedUser.fullName : "N/A"}</p>
                                </Col>
                                <Col span="8">

                                  <p className="text-color-6b778c mar-b-5">Approved on</p>
                                  <p className="font-16 mar-b-0">{row && row.responseTime != null ? moment(row.responseTime).format("ll") : "N/A"}</p>
                                </Col>
                                <Col span="8">
                                  <p className={handleStatusApprovedDelay(row).status}>{handleStatusApprovedDelay(row).msg}</p>
                                  {/* <p className="text-color-danger mar-t-15 font-17">Delayed by 2 hours</p> */}
                                </Col>
                              </Row>

                            </Space>
                          </div>
                        </>
                      );
                    })
                    :
                    (
                      <div className="mar-b-30">
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                      </div>
                    )

                  }


                  <h1
                    style={{
                      fontStyle: "normal",
                      fontWeight: "600",
                      fontSize: 22,
                      color: "#292c40",
                      marginBottom: 12,
                      marginTop: 15,
                    }}
                  >
                    Seen Stamp Time Log
                  </h1>
                  <Table
                    columns={columns}
                    pagination={false}
                    // pagination={{
                    //   position: [ntop, nbottom],
                    //   size: "small",
                    //   defaultPageSize: 8,
                    //   hideOnSinglePage: true,
                    // }}
                    dataSource={dataSource}
                    bordered
                    className="mytablecss table-seen-stamp-time-log"
                  />

                  {concurrentDoc && concurrentDoc.length > 0 ? <>
                    <h1
                      style={{
                        fontStyle: "normal",
                        fontWeight: "600",
                        fontSize: 22,
                        color: "#292c40",
                        marginBottom: 12,
                        marginTop: 20,
                      }}
                    >
                      Concurrent Seen Stamp Log
                    </h1>
                    <Table
                      columns={columnsForConcurentlog}
                      pagination={false}
                      // pagination={{
                      //   position: [ntop, nbottom],
                      //   size: "small",
                      //   defaultPageSize: 8,
                      //   hideOnSinglePage: true,
                      // }}
                      dataSource={dataSource2}
                      bordered

                      className="mytablecss table-seen-stamp-time-log"
                    />
                  </>
                    :
                    <></>
                  }


                </Col>
              </Row>
            </Space>

          </div>
        </div>
      </Container>
    </>
  );
}
